// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"4f7870ea","759":"77cb0276"}[chunkId] + ".chunk.css";
};